// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"72":"6884ca4d","116":"a379c1c4","314":"2549f660","352":"cb2c5c7e"}[chunkId] + ".chunk.css";
};